import { ssrApi } from 'api/ssr';
import { AllCasinosPage } from 'components/template/collection-casino';
import { IRegionItem, ICasino } from 'constants/types';
import { ParsedUrlQuery } from 'querystring';

const PER_PAGE = 12;

export default function AllCasinos({
  licenses,
  software,
  countries,
  casinos,
  casinosCount,
}: {
  licenses: string[];
  software: string[];
  countries: IRegionItem[];
  casinos: ICasino[];
  casinosCount: number;
}) {
  return (
    <AllCasinosPage
      licenses={licenses}
      software={software}
      countries={countries}
      casinos={casinos}
      casinosCount={casinosCount}
    />
  );
}

export async function getServerSideProps({ query }: { query: ParsedUrlQuery }) {
  const page = Math.max(1, Number(query.page ?? 1));

  const [
    { results: licenses },
    { results: software },
    { results: countries },
    casinosData,
  ] = await Promise.all([
    ssrApi.licenses.list(),
    ssrApi.software.list(),
    ssrApi.countries.list(),
    ssrApi.casinos.list({
      page: 1,
      limit: PER_PAGE * page,
      sortBy: 'popular',
    }),
  ]);

  return {
    props: {
      licenses,
      software,
      countries,
      casinos: casinosData.results ?? [],
      casinosCount: Number(casinosData.count ?? 0),
    },
  };
}
